import React, { useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { Typography } from '@/components/Atoms';
import { ArmiesSvg } from '@/components/Svg';
import CommandCenterTabItem from '../../TabItem';
import ArmiesList from './ArmiseList';

const tabs: Array<{ value: string; label?: string }> = [
  {
    value: 'Commanders',
  },
  // {
  //   value: 'My armies',
  // },
  // {
  //   value: 'units',
  // },
];

const ArmiesSection = () => {
  const { t } = useTranslate('commandCenter');
  const [tabValue, setTabValue] = useState<string>(tabs[0].value);

  return (
    <>
      <div className='w-full justify-between flex pb-2'>
        <Typography size='s16ToS12' className='text-[#979797] lg:text-[11px]' isBold>
          {t('LEFT_SECTION.armiesSection.title')}
        </Typography>
        <ArmiesSvg />
      </div>
      <div className='flex mt-2 gap-2'>
        {tabs.map((item) => (
          <CommandCenterTabItem onClick={() => setTabValue(item.value)} active={item.value === tabValue} key={item.value}>
            {item.label || item.value}
          </CommandCenterTabItem>
        ))}
      </div>
      <div className='w-full h-[1px] bg-[#4F4F4F]'></div>

      <ArmiesList />

      {/* Access Denied */}
      {/* ******************* */}
      {/* <div className='w-full h-full flex items-center justify-center'>
      <div className='w-[163px] h-[192px] flex flex-col items-center justify-center border border-[#5C5C5C] rounded-[22px]'>
        <div className='w-[86px] h-[80px] mb-2'>
          <Image src={'/images/access-denied.png'} layout='responsive' alt='access-denied' width={'86px'} height={'80px'} />
        </div>
        <Typography size='s14ToS12' isBold>
          ACCESS DENIED
        </Typography>
        <Typography className='text-[#909090]' size='s12ToS12'>
          Higher Rank Required
        </Typography>
        <ArmiesSvg />
      </div>
    </div> */}
    </>
  );
};

export default ArmiesSection;
